import React from "react";
import TextInfo, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import styles from "./style";
import IconGlyph from "@gc-npm/components.icon-glyph";
import { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";
import Image from "@/component/c-image";

const ADVANTAGE_ITEMS = [{
  icon: "porcentaje-estrella-m",
  text: "Calidad excelente a precios irresistibles"
},
{
  icon: "check-estrella-m",
  text: "Garantía hasta 2 años y prueba de 14 días en reacondicionados"
},
{
  icon: "eco-planta-m",
  text: "Contribuye al cuidado del medio ambiente"
},
{
  icon: "movil-planta-m",
  text: "Reacondicionados de Apple, Samsung y más"
}]

const RoombaPriceBanner = () => {
  return (
    <>
      <div className="roomba-price-banner">
        <div className="banner-video-container">
          <video className="banner-video-desktop" autoPlay loop muted >
            <source src="https://ssr.col.movistar.es/static/videos/dispos/banner-reacondicionados-ok.webm" type="video/webm" />
            <source src="https://ssr.col.movistar.es/static/videos/dispos/banner-reacondicionados-ok.mp4" type="video/mp4" />
          </video>
          <div className="banner-video-mobile">
            <Image
              src={"/content/dam/movistar/estaticos/fondos/banner-static-tienda.jpg"}
              width={1000}
              height={150}
              alt=""
              objectFit="contain"
            />
          </div>
          <div className="banner-overlay">
            <div className="title-desktop">
              <TextInfo
                size={TEXT_SIZE.T3}
                text="Descubre las mejores ofertas en <b>dispositivos outlet</b> y <b>reacondicionados</b>"
                color={TEXT_COLOR.WHITE}
              />
            </div>
            <div className="title-mobile">
              <TextInfo
                size={TEXT_SIZE.T4}
                text="Descubre las mejores ofertas en <b>dispositivos outlet</b> y <b>reacondicionados</b>"
                color={TEXT_COLOR.WHITE}
              />
            </div>
          </div>
        </div>
        <div className="advantages">
          {
            ADVANTAGE_ITEMS.map(({ text, icon }, index) => (
              <div className="advantage-item" key={index}>
                <IconGlyph
                  id={icon}
                  height={36}
                  color={COLOR_DICTIONARY.MOVISTAR_BLUE}
                  className="chevron"
                />
                <TextInfo
                  size={TEXT_SIZE.CAPTION3}
                  text={text}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  align={TEXT_ALIGN.CENTER}
                />
              </div>
            ))
          }
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default RoombaPriceBanner;
